import WorkflowElement from "../element"

export default class AddButton extends WorkflowElement {
  static get elementName() {
    return "workflow-add-button"
  }
  static get observedAttributes() {
    return ["data-extendable"]
  }

  initialize() {
    this.role = "button"
    this.setAttribute("tabindex", "0")
    this.toggle = this.toggle.bind(this)
    this.addEventListener("click", this.toggle)
    addEventListener("keydown", this.toggle)
    this.addEventListener("workflow-popover:close", this.close)
    this.boundClose = this.close.bind(this)
  }

  connectedCallback() {
    if (this.dataset.type) {
      this.querySelector(
        ".workflow-add-button-label"
      ).innerHTML = `Add ${this.dataset.type} node`
    }
    this.openEvent = new CustomEvent("va-popover:open", {
      detail: {
        anchor: this,
        isEntryNode: !!this.dataset.entryNode
      }
    })
  }

  attributeChangedCallback(attributeName, oldValue, newValue) {
    if (attributeName == "data-extendable" && newValue == "false") {
      this.disable()
    }
  }

  close() {
    this.dataset.opened = false
    window.vaPopoverOpen = false
    Workflow.removeEventListener("va-popover:close", this.boundClose)
    Workflow.dispatchEvent(new CustomEvent("va-popover:close"))
  }

  open() {
    Workflow.dispatchEvent(new CustomEvent("va-popover:close"))
    Workflow.addEventListener("va-popover:close", this.boundClose)
    window.vaPopoverOpen = true
    Workflow.dispatchEvent(this.openEvent)
    this.dataset.opened = true
  }

  toggle(event) {
    if (
      event instanceof KeyboardEvent &&
      event.key !== "Enter" &&
      event.key !== " "
    ) {
      return
    }

    event.stopPropagation()

    if (event.target != this) {
      return
    }
    event.stopPropagation()

    if (this.dataset.opened == "true") {
      this.close()
    } else {
      this.open()
    }
  }

  disable() {
    this.removeEventListener("click", this.toggle)
    this.removeEventListener("workflow-popover:close", this.close)
    this.classList.add("disabled")

    $(this).tooltip({
      container: "body",
      placement: "left"
    })
  }
}

customElements.get(AddButton.elementName) ||
  customElements.define(AddButton.elementName, AddButton)
